/**
 * @generated SignedSource<<595d3910173c2d123487818b81fe0a72>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type authorFilter_softwareCodePage$data = ReadonlyArray<{
  readonly author: {
    readonly accountId: string;
    readonly name: string;
    readonly picture: AGG$URL;
  } | null | undefined;
  readonly " $fragmentType": "authorFilter_softwareCodePage";
}>;
export type authorFilter_softwareCodePage$key = ReadonlyArray<{
  readonly " $data"?: authorFilter_softwareCodePage$data;
  readonly " $fragmentSpreads": FragmentRefs<"authorFilter_softwareCodePage">;
}>;

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "authorFilter_softwareCodePage",
  "selections": [
    {
      "kind": "LinkedField",
      "name": "author",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "accountId"
        },
        {
          "kind": "ScalarField",
          "name": "name"
        },
        {
          "kind": "ScalarField",
          "name": "picture"
        }
      ]
    }
  ],
  "type": "DevOpsPullRequestDetails"
};

(node as any).hash = "7235aa45c28bed2bd880d3c51038acd7";

export default node;
